import {
  CenterExceptionalExpense,
  CenterExceptionalExpenseInput
} from '../../../lib/types/models/center/center-exceptional-expenses'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function createCenterExceptionalExpense(id: number, data: CenterExceptionalExpenseInput) {
  return restApiClient
    .url(constructApiUrl(API.centers.createCenterExceptionalExpense.url, { id }))
    .post<CenterExceptionalExpense, CenterExceptionalExpenseInput>(data)
}
